import { createSelector } from 'reselect';
import { name } from '../reducers/user';
import { createDomainScopedSelector } from './domainSelectorHelper';

const makeSelectUser = () => createSelector(createDomainScopedSelector(name), (substate) => substate);

export default makeSelectUser;
